import { render, staticRenderFns } from "./BenefitDetail.vue?vue&type=template&id=0597cc4a&scoped=true"
import script from "./BenefitDetail.vue?vue&type=script&lang=js"
export * from "./BenefitDetail.vue?vue&type=script&lang=js"
import style0 from "./BenefitDetail.vue?vue&type=style&index=0&id=0597cc4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0597cc4a",
  null
  
)

export default component.exports